import { IS_DEV_ENV, HOGAN_CONFIG, PINO_CONFIG } from '../constants/config';
import { LoggerFactory } from '@cvent/logging/LoggerFactory';
import pino from 'pino';

/**
 * Function wraps `console.log` to use console log safely and to have single
 * place to control all system logging (may be implemented in future).
 *
 * @param data  Any data that will be passed to `console.log`.
 */
// tslint:disable-next-line:no-any
export function log(...data: any[]) {
    if (IS_DEV_ENV) {
        // tslint:disable-next-line:no-console
        console.log(...data);
    }
}

declare let window: {
    __DD_SERVICE__: string;
    __DD_ENV__: string;
    __DD_VERSION__: string;
};

class AppLogger {
    loggerInitialized: boolean = false;
    loggerInstance: any = pino(PINO_CONFIG);

    checkWindowVariables() {
        return typeof window !== 'undefined' && window.__DD_ENV__ && window.__DD_VERSION__ && window.__DD_SERVICE__;
    }

    createLogger() {
        if (this.checkWindowVariables()) {
            if(!this.loggerInitialized){
                this.initLogger();
            }
            this.loggerInstance = LoggerFactory.create('App');
        } else {
            this.loggerInstance = pino(PINO_CONFIG);
        }
        return this.loggerInstance;
    }

    initLogger() {
        const windowVaribaleDefined = this.checkWindowVariables();
        if (this.loggerInitialized || !windowVaribaleDefined) {
            return this.loggerInitialized;
        }
        if (windowVaribaleDefined) {
            LoggerFactory.initConfig({
                datadogOptions: {
                    clientToken: HOGAN_CONFIG.datadog.clientToken,
                    service: window.__DD_SERVICE__,
                    env: window.__DD_ENV__,
                    version: window.__DD_VERSION__,
                    forwardConsoleLogs: ['warn','error'],
                    forwardErrorsToLogs: true,
                },
                loggerOptions: {
                    level: 'warn'
                }
            });
            this.loggerInitialized = true;
        }
        return this.loggerInitialized;
    }
}

export default new AppLogger();